// import React, { useState } from 'react';
// import {
//   LayoutDashboard, RefreshCcw, BarChart2, HeadphonesIcon,
//   LogOut, Settings, Menu, X, AlertTriangle, ChevronDown, ChevronRight
// } from 'lucide-react';
// import './Sidebar.css';

// const NAV_COLORS = {
//   dashboard: { active: '#FF9393', glow: 'rgba(255,147,147,0.35)' },
//   recharge:  { active: '#FF9393', glow: 'rgba(255,147,147,0.35)' },
//   analytics: { active: '#FF9393', glow: 'rgba(255,147,147,0.35)' },
//   support:   { active: '#FF9393', glow: 'rgba(255,147,147,0.35)' },
//   profile:   { active: '#FF9393', glow: 'rgba(255,147,147,0.35)' },
// };

// export default function Sidebar({
//   activePage, setActivePage, onSignOut,
//   session, collapsed, onToggle, role,
//   miscSubPage, setMiscSubPage,
// }) {
//   const payload  = session?.getIdToken()?.payload || {};
//   const username = payload.email || payload['cognito:username'] || payload.sub?.slice(0,8) || 'Admin';
//   const initial  = username.charAt(0).toUpperCase();
//   const isAdmin  = role === 'admin';

//   // Track whether Miscellaneous sub-menu is expanded
//   const [miscExpanded, setMiscExpanded] = useState(
//     activePage === 'miscellaneous'
//   );

//   const navItems = [
//     { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
//     { id: 'recharge',  label: 'Recharge',  icon: RefreshCcw      },
//     ...(isAdmin ? [{ id: 'analytics',    label: 'Analytics',     icon: BarChart2       }] : []),
//     ...(isAdmin ? [{ id: 'miscellaneous', label: 'Miscellaneous', icon: AlertTriangle, hasChildren: true }] : []),
//     ...(isAdmin ? [{ id: 'support',       label: 'Support',       icon: HeadphonesIcon  }] : []),
//   ];

//   const miscChildren = [
//     { id: 'pump',         label: 'Pump Tamper',   icon: '🔧', tamCode: '1' },
//     { id: 'flow',         label: 'Flow Sensor',   icon: '💧', tamCode: '2' },
//     { id: 'dryrun',       label: 'Dry Run',       icon: '🌬️', tamCode: '3' },
//     { id: 'refreshments', label: 'Refreshments',  icon: '♻️', tamCode: '4' },
//   ];

//   const handleNav = (id) => {
//     if (id === 'miscellaneous') {
//       setMiscExpanded(e => !e);
//       setActivePage('miscellaneous');
//       if (setMiscSubPage) setMiscSubPage(null);
//     } else {
//       if (setMiscSubPage) setMiscSubPage(null);
//       setActivePage(id);
//     }
//     if (window.innerWidth < 768) onToggle();
//   };

//   const handleMiscSub = (subId) => {
//     setMiscExpanded(true);
//     setMiscSubPage(subId);
//     if (window.innerWidth < 768) onToggle();
//   };

//   return (
//     <aside className={`sidebar ${collapsed ? 'sidebar-collapsed' : ''}`}>

//       {/* ── Brand row ── */}
//       <div className="sidebar-brand">
//         <button className="hamburger-btn" onClick={onToggle}
//           title={collapsed ? 'Open menu' : 'Close menu'}>
//           {collapsed
//             ? <Menu  size={18} color="#fff"/>
//             : <X     size={18} color="#fff"/>
//           }
//         </button>
//         <div className="brand-content">
//           <div>
//             <div className="brand-name">Havells Admin</div>
//             <div className="brand-sub">Device Management</div>
//           </div>
//         </div>
//       </div>

//       {/* ── User pill ── */}
//       <div className="sidebar-user" onClick={() => handleNav('profile')}
//         title={collapsed ? username : 'View Profile'}>
//         <div className="sidebar-user-avatar">
//           {initial}
//         </div>
//         <div className="sidebar-user-info">
//           <div className="sidebar-user-name">{username}</div>
//           <div className="sidebar-user-role">
//             {activePage === 'profile' ? '● Active' : 'View Profile'}
//           </div>
//         </div>
//       </div>

//       {/* ── Menu label ── */}
//       {!collapsed && (
//         <div style={{
//           fontSize: 9, fontWeight: 700, letterSpacing: 1.2,
//           color: 'rgba(255,255,255,0.6)',
//           padding: '10px 20px 4px',
//           textTransform: 'uppercase',
//         }}>Menu</div>
//       )}

//       {/* ── Nav ── */}
//       <nav className="sidebar-nav">
//         {navItems.map(({ id, label, icon: Icon, hasChildren }) => {
//           const isActive = activePage === id;
//           const isMiscOpen = id === 'miscellaneous' && miscExpanded && !collapsed;

//           return (
//             <React.Fragment key={id}>
//               <button
//                 className={`nav-item ${isActive ? 'active' : ''}`}
//                 onClick={() => handleNav(id)}
//                 title={collapsed ? label : ''}
//                 style={isActive ? {
//                   background: 'rgba(255,255,255,0.25)',
//                   borderColor: 'rgba(255,255,255,0.4)',
//                   boxShadow: '0 2px 16px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.3)',
//                 } : {}}
//               >
//                 <div style={{
//                   width: 30, height: 30, borderRadius: 9,
//                   display: 'flex', alignItems: 'center', justifyContent: 'center',
//                   flexShrink: 0,
//                   background: isActive ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.08)',
//                   transition: 'all 0.2s ease',
//                 }}>
//                   <Icon size={15} color={isActive ? '#fff' : 'rgba(255,255,255,0.8)'} />
//                 </div>
//                 <span className="nav-label" style={{ fontWeight: isActive ? 700 : 500, color: isActive ? '#fff' : 'rgba(255,255,255,0.8)', flex:1 }}>
//                   {label}
//                 </span>
//                 {/* Chevron for Miscellaneous */}
//                 {hasChildren && !collapsed && (
//                   <span style={{ marginLeft:'auto', flexShrink:0, opacity:.7, transition:'transform .2s',
//                     transform: isMiscOpen ? 'rotate(0deg)' : 'rotate(-90deg)', display:'flex' }}>
//                     <ChevronDown size={13} color="rgba(255,255,255,0.8)"/>
//                   </span>
//                 )}
//                 {isActive && !collapsed && !hasChildren && (
//                   <div style={{ marginLeft:'auto', width:5, height:5, borderRadius:'50%', background:'#fff', flexShrink:0 }}/>
//                 )}
//               </button>

//               {/* Sub-menu for Miscellaneous */}
//               {id === 'miscellaneous' && isMiscOpen && (
//                 <div style={{
//                   marginLeft:16, marginRight:8,
//                   borderLeft:'2px solid rgba(255,255,255,0.15)',
//                   paddingLeft:8, marginTop:2, marginBottom:4,
//                   display:'flex', flexDirection:'column', gap:2,
//                   animation:'subMenuIn .2s ease',
//                 }}>
//                   <style>{`
//                     @keyframes subMenuIn {
//                       from { opacity:0; transform:translateY(-6px); }
//                       to   { opacity:1; transform:translateY(0); }
//                     }
//                   `}</style>
//                   {miscChildren.map(child => {
//                     const isSubActive = activePage === 'miscellaneous' && miscSubPage === child.id;
//                     return (
//                       <button key={child.id}
//                         onClick={() => handleMiscSub(child.id)}
//                         style={{
//                           display:'flex', alignItems:'center', gap:10,
//                           padding:'8px 12px', borderRadius:10, border:'none',
//                           background: isSubActive ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.05)',
//                           cursor:'pointer', width:'100%', textAlign:'left',
//                           transition:'background .15s',
//                           fontFamily:'inherit',
//                         }}
//                       >
//                         <div style={{
//                           width:26, height:26, borderRadius:8, flexShrink:0,
//                           background: isSubActive ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.1)',
//                           display:'flex', alignItems:'center', justifyContent:'center',
//                           fontSize:13,
//                         }}>
//                           {child.icon}
//                         </div>
//                         <span style={{
//                           fontSize:12, fontWeight: isSubActive ? 700 : 500,
//                           color: isSubActive ? '#fff' : 'rgba(255,255,255,0.75)',
//                           letterSpacing:-.2,
//                         }}>
//                           {child.label}
//                         </span>
//                         {isSubActive && (
//                           <div style={{ marginLeft:'auto', width:4, height:4, borderRadius:'50%',
//                             background:'#fff', flexShrink:0 }}/>
//                         )}
//                       </button>
//                     );
//                   })}
//                 </div>
//               )}
//             </React.Fragment>
//           );
//         })}
//       </nav>

//       {/* ── Account label ── */}
//       {!collapsed && (
//         <div style={{
//           fontSize: 9, fontWeight: 700, letterSpacing: 1.2,
//           color: 'rgba(255,255,255,0.6)',
//           padding: '4px 20px 4px',
//           textTransform: 'uppercase',
//         }}>Account</div>
//       )}

//       {/* ── Footer ── */}
//       <div className="sidebar-footer">
//         {/* Profile */}
//         {(() => {
//           const isActive = activePage === 'profile';
//           return (
//             <button
//               className={`nav-item ${isActive ? 'active' : ''}`}
//               onClick={() => handleNav('profile')}
//               title={collapsed ? 'Profile' : ''}
//               style={isActive ? {
//                 background: 'rgba(255,255,255,0.25)',
//                 borderColor: 'rgba(255,255,255,0.4)',
//                 boxShadow: '0 2px 16px rgba(0,0,0,0.1)',
//               } : {}}
//             >
//               <div style={{
//                 width: 30, height: 30, borderRadius: 9,
//                 display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 flexShrink: 0,
//                 background: isActive ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.08)',
//                 transition: 'all 0.2s ease',
//               }}>
//                 <Settings size={15} color={activePage === 'profile' ? '#fff' : 'rgba(255,255,255,0.8)'} />
//               </div>
//               <span className="nav-label" style={{ fontWeight: activePage === 'profile' ? 700 : 500, color: activePage === 'profile' ? '#fff' : 'rgba(255,255,255,0.8)' }}>
//                 Profile
//               </span>
//               {isActive && !collapsed && (
//                 <div style={{ marginLeft:'auto', width:5, height:5, borderRadius:'50%', background:'#fff', flexShrink:0 }}/>
//               )}
//             </button>
//           );
//         })()}

//         {/* Sign Out */}
//         <button className="nav-item logout" onClick={onSignOut}
//           title={collapsed ? 'Sign Out' : ''}>
//           <div style={{
//             width: 30, height: 30, borderRadius: 9, flexShrink: 0,
//             display: 'flex', alignItems: 'center', justifyContent: 'center',
//             background: 'rgba(0,0,0,0.08)',
//             transition: 'all 0.2s ease',
//           }}>
//             <LogOut size={15} color="rgba(255,255,255,0.8)" />
//           </div>
//           <span className="nav-label" style={{ color: 'rgba(255,255,255,0.8)', fontWeight: 500 }}>
//             Sign Out
//           </span>
//         </button>
//       </div>
//     </aside>
//   );
// }



// import React, { useState } from 'react';
// import {
//   LayoutDashboard, RefreshCcw, BarChart2, HeadphonesIcon,
//   LogOut, Settings, Menu, X, AlertTriangle, ChevronDown
// } from 'lucide-react';
// import './Sidebar.css';

// export default function Sidebar({
//   activePage, setActivePage, onSignOut,
//   session, collapsed, onToggle, role,
//   miscSubPage, setMiscSubPage,
// }) {
//   const payload  = session?.getIdToken()?.payload || {};
//   const username = payload.email || payload['cognito:username'] || payload.sub?.slice(0,8) || 'Admin';
//   const initial  = username.charAt(0).toUpperCase();
//   const isAdmin  = role === 'admin';

//   const [miscExpanded, setMiscExpanded] = useState(
//     activePage === 'miscellaneous'
//   );

//   const navItems = [
//     { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
//     { id: 'recharge',  label: 'Recharge',  icon: RefreshCcw      },
//     ...(isAdmin ? [{ id: 'analytics',     label: 'Analytics',     icon: BarChart2       }] : []),
//     ...(isAdmin ? [{ id: 'miscellaneous', label: 'Miscellaneous', icon: AlertTriangle, hasChildren: true }] : []),
//     ...(isAdmin ? [{ id: 'support',       label: 'Support',       icon: HeadphonesIcon  }] : []),
//   ];

//   // ── 4 sub-items ──
//   const miscChildren = [
//     { id: 'tamper',        label: 'Tamper',         icon: '⚠️' },
//     { id: 'dryrun',        label: 'Dry Run',        icon: '🌬️' },
//     { id: 'refreshments',  label: 'Refreshments',   icon: '♻️' },
//     { id: 'batteryhealth', label: 'Battery Health',  icon: '🔋' },
//   ];

//   const handleNav = (id) => {
//     if (id === 'miscellaneous') {
//       setMiscExpanded(e => !e);
//       setActivePage('miscellaneous');
//       if (setMiscSubPage) setMiscSubPage(null);
//     } else {
//       if (setMiscSubPage) setMiscSubPage(null);
//       setActivePage(id);
//     }
//     if (window.innerWidth < 768) onToggle();
//   };

//   const handleMiscSub = (subId) => {
//     setActivePage('miscellaneous');
//     setMiscExpanded(true);
//     setMiscSubPage(subId);
//     if (window.innerWidth < 768) onToggle();
//   };

//   return (
//     <aside className={`sidebar ${collapsed ? 'sidebar-collapsed' : ''}`}>
//       <div className="sidebar-brand">
//         <button className="hamburger-btn" onClick={onToggle}
//           title={collapsed ? 'Open menu' : 'Close menu'}>
//           {collapsed ? <Menu size={18} color="#fff"/> : <X size={18} color="#fff"/>}
//         </button>
//         <div className="brand-content">
//           <div>
//             <div className="brand-name">Havells Admin</div>
//             <div className="brand-sub">Device Management</div>
//           </div>
//         </div>
//       </div>

//       <div className="sidebar-user" onClick={() => handleNav('profile')}
//         title={collapsed ? username : 'View Profile'}>
//         <div className="sidebar-user-avatar">{initial}</div>
//         <div className="sidebar-user-info">
//           <div className="sidebar-user-name">{username}</div>
//           <div className="sidebar-user-role">
//             {activePage === 'profile' ? '● Active' : 'View Profile'}
//           </div>
//         </div>
//       </div>

//       {!collapsed && (
//         <div style={{ fontSize:9, fontWeight:700, letterSpacing:1.2,
//           color:'rgba(255,255,255,0.6)', padding:'10px 20px 4px',
//           textTransform:'uppercase' }}>Menu</div>
//       )}

//       <nav className="sidebar-nav">
//         {navItems.map(({ id, label, icon: Icon, hasChildren }) => {
//           const isActive = activePage === id;
//           const isMiscOpen = id === 'miscellaneous' && miscExpanded && !collapsed;

//           return (
//             <React.Fragment key={id}>
//               <button
//                 className={`nav-item ${isActive ? 'active' : ''}`}
//                 onClick={() => handleNav(id)}
//                 title={collapsed ? label : ''}
//                 style={isActive ? {
//                   background:'rgba(255,255,255,0.25)',
//                   borderColor:'rgba(255,255,255,0.4)',
//                   boxShadow:'0 2px 16px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.3)',
//                 } : {}}
//               >
//                 <div style={{
//                   width:30, height:30, borderRadius:9,
//                   display:'flex', alignItems:'center', justifyContent:'center',
//                   flexShrink:0,
//                   background: isActive ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.08)',
//                   transition:'all 0.2s ease',
//                 }}>
//                   <Icon size={15} color={isActive ? '#fff' : 'rgba(255,255,255,0.8)'} />
//                 </div>
//                 <span className="nav-label" style={{
//                   fontWeight: isActive ? 700 : 500,
//                   color: isActive ? '#fff' : 'rgba(255,255,255,0.8)', flex:1
//                 }}>{label}</span>
//                 {hasChildren && !collapsed && (
//                   <span style={{ marginLeft:'auto', flexShrink:0, opacity:.7,
//                     transition:'transform .2s',
//                     transform: isMiscOpen ? 'rotate(0deg)' : 'rotate(-90deg)', display:'flex' }}>
//                     <ChevronDown size={13} color="rgba(255,255,255,0.8)"/>
//                   </span>
//                 )}
//                 {isActive && !collapsed && !hasChildren && (
//                   <div style={{ marginLeft:'auto', width:5, height:5, borderRadius:'50%',
//                     background:'#fff', flexShrink:0 }}/>
//                 )}
//               </button>

//               {id === 'miscellaneous' && isMiscOpen && (
//                 <div style={{
//                   marginLeft:16, marginRight:8,
//                   borderLeft:'2px solid rgba(255,255,255,0.15)',
//                   paddingLeft:8, marginTop:2, marginBottom:4,
//                   display:'flex', flexDirection:'column', gap:2,
//                   animation:'subMenuIn .2s ease',
//                 }}>
//                   <style>{`
//                     @keyframes subMenuIn {
//                       from { opacity:0; transform:translateY(-6px); }
//                       to   { opacity:1; transform:translateY(0); }
//                     }
//                   `}</style>
//                   {miscChildren.map(child => {
//                     const isSubActive = activePage === 'miscellaneous' && miscSubPage === child.id;
//                     return (
//                       <button key={child.id}
//                         onClick={() => handleMiscSub(child.id)}
//                         style={{
//                           display:'flex', alignItems:'center', gap:10,
//                           padding:'8px 12px', borderRadius:10, border:'none',
//                           background: isSubActive ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.05)',
//                           cursor:'pointer', width:'100%', textAlign:'left',
//                           transition:'background .15s', fontFamily:'inherit',
//                         }}
//                       >
//                         <div style={{
//                           width:26, height:26, borderRadius:8, flexShrink:0,
//                           background: isSubActive ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.1)',
//                           display:'flex', alignItems:'center', justifyContent:'center',
//                           fontSize:13,
//                         }}>{child.icon}</div>
//                         <span style={{
//                           fontSize:12, fontWeight: isSubActive ? 700 : 500,
//                           color: isSubActive ? '#fff' : 'rgba(255,255,255,0.75)',
//                           letterSpacing:-.2,
//                         }}>{child.label}</span>
//                         {isSubActive && (
//                           <div style={{ marginLeft:'auto', width:4, height:4, borderRadius:'50%',
//                             background:'#fff', flexShrink:0 }}/>
//                         )}
//                       </button>
//                     );
//                   })}
//                 </div>
//               )}
//             </React.Fragment>
//           );
//         })}
//       </nav>

//       {!collapsed && (
//         <div style={{ fontSize:9, fontWeight:700, letterSpacing:1.2,
//           color:'rgba(255,255,255,0.6)', padding:'4px 20px 4px',
//           textTransform:'uppercase' }}>Account</div>
//       )}

//       <div className="sidebar-footer">
//         {(() => {
//           const isActive = activePage === 'profile';
//           return (
//             <button className={`nav-item ${isActive ? 'active' : ''}`}
//               onClick={() => handleNav('profile')}
//               title={collapsed ? 'Profile' : ''}
//               style={isActive ? {
//                 background:'rgba(255,255,255,0.25)',
//                 borderColor:'rgba(255,255,255,0.4)',
//                 boxShadow:'0 2px 16px rgba(0,0,0,0.1)',
//               } : {}}>
//               <div style={{
//                 width:30, height:30, borderRadius:9,
//                 display:'flex', alignItems:'center', justifyContent:'center',
//                 flexShrink:0,
//                 background: isActive ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.08)',
//                 transition:'all 0.2s ease',
//               }}>
//                 <Settings size={15} color={isActive ? '#fff' : 'rgba(255,255,255,0.8)'} />
//               </div>
//               <span className="nav-label" style={{
//                 fontWeight: isActive ? 700 : 500,
//                 color: isActive ? '#fff' : 'rgba(255,255,255,0.8)'
//               }}>Profile</span>
//               {isActive && !collapsed && (
//                 <div style={{ marginLeft:'auto', width:5, height:5, borderRadius:'50%',
//                   background:'#fff', flexShrink:0 }}/>
//               )}
//             </button>
//           );
//         })()}

//         <button className="nav-item logout" onClick={onSignOut}
//           title={collapsed ? 'Sign Out' : ''}>
//           <div style={{
//             width:30, height:30, borderRadius:9, flexShrink:0,
//             display:'flex', alignItems:'center', justifyContent:'center',
//             background:'rgba(0,0,0,0.08)', transition:'all 0.2s ease',
//           }}>
//             <LogOut size={15} color="rgba(255,255,255,0.8)" />
//           </div>
//           <span className="nav-label" style={{ color:'rgba(255,255,255,0.8)', fontWeight:500 }}>
//             Sign Out
//           </span>
//         </button>
//       </div>
//     </aside>
//   );
// }


import React, { useState } from 'react';
import {
  LayoutDashboard, RefreshCcw, BarChart2, HeadphonesIcon,
  LogOut, Settings, Menu, X, AlertTriangle, ChevronDown, UserCog
} from 'lucide-react';
import './Sidebar.css';

export default function Sidebar({
  activePage, setActivePage, onSignOut,
  session, collapsed, onToggle, role, permissions,
  miscSubPage, setMiscSubPage,
}) {
  const payload    = session?.getIdToken()?.payload || {};
  const username   = payload.email || payload['cognito:username'] || payload.sub?.slice(0,8) || 'Admin';
  const initial    = username.charAt(0).toUpperCase();
  const isAdmin    = role === 'admin' || role === 'super_admin';
  const isMgr      = role === 'service_manager';
  const perms      = permissions || [];
  const hasPerm    = (p) => perms.includes('all') || perms.includes(p);

  // Only kishore is Super Admin; all other admin-role accounts are just Admin
  const SUPER_ADMIN_EMAILS = ['kishore@hoags.in'];
  const isSuperAdmin = isAdmin && SUPER_ADMIN_EMAILS.includes(username.toLowerCase());

  const ROLE_LABEL = {
    admin:             isSuperAdmin ? 'Super Admin' : 'Admin',
    service_manager:   'Manager',
    customer_engineer: 'Support Engineer',
  };
  const roleLabel = ROLE_LABEL[role] || 'Admin';

  // Brand title: "Havells" only, role shown on second line
  const brandTitle = 'Havells';
  const brandSub   = roleLabel;

  // Sidebar colour theme by role
  const ROLE_THEME = {
    admin: {
      bg: 'linear-gradient(175deg, rgba(255,44,44,0.97) 0%, rgba(200,20,20,0.98) 40%, rgba(180,15,15,0.99) 100%)',
      accent: '#DC2626',
    },
    service_manager: {
      bg: 'linear-gradient(175deg, rgba(0,100,255,0.97) 0%, rgba(0,70,210,0.98) 40%, rgba(0,56,179,0.99) 100%)',
      accent: '#2563EB',
    },
    customer_engineer: {
      bg: 'linear-gradient(175deg, rgba(124,58,237,0.97) 0%, rgba(91,33,182,0.98) 40%, rgba(76,29,149,0.99) 100%)',
      accent: '#7C3AED',
    },
  };
  const theme = ROLE_THEME[role] || ROLE_THEME.admin;

  const [miscExpanded, setMiscExpanded] = useState(
    activePage === 'miscellaneous'
  ); 

  // Admin gets everything. Managers get a permission-gated subset (tied to
  // the checkboxes in Role Management) — Miscellaneous + Role Management are
  // always visible to every manager regardless of permissions.
  const navItems = isAdmin ? [
    { id: 'dashboard',      label: 'Dashboard',       icon: LayoutDashboard },
    { id: 'recharge',       label: 'Recharge',        icon: RefreshCcw      },
    { id: 'analytics',      label: 'Analytics',       icon: BarChart2       },
    { id: 'miscellaneous',  label: 'Miscellaneous',   icon: AlertTriangle, hasChildren: true },
    { id: 'support',        label: 'Support',         icon: HeadphonesIcon  },
    { id: 'rolemanagement', label: 'Role Management', icon: UserCog        },
  ] : isMgr ? [
    ...(hasPerm('view_analytics') ? [{ id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard }] : [
      { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard }, // always show for manager
    ]),
    ...(hasPerm('recharge')       ? [{ id: 'recharge',  label: 'Recharge',  icon: RefreshCcw      }] : []),
    ...(hasPerm('view_analytics') ? [{ id: 'analytics', label: 'Analytics', icon: BarChart2       }] : []),
    { id: 'miscellaneous',  label: 'Miscellaneous',   icon: AlertTriangle, hasChildren: true },
    { id: 'support',        label: 'Support',         icon: HeadphonesIcon  },
    { id: 'rolemanagement', label: 'Role Management', icon: UserCog        },
  ] : [
    // Customer Engineer nav
    { id: 'dashboard',      label: 'Dashboard',       icon: LayoutDashboard },
    { id: 'miscellaneous',  label: 'Miscellaneous',   icon: AlertTriangle, hasChildren: true },
    { id: 'support',        label: 'My Tickets',      icon: HeadphonesIcon  },
    { id: 'rolemanagement', label: 'Role Management', icon: UserCog        },
  ];

  // ── 4 sub-items under Miscellaneous ──
  const miscChildren = [
    { id: 'tamper',        label: 'Tamper',         icon: '⚠️' },
    { id: 'dryrun',        label: 'Higher OutFlow', icon: '🌬️' },
    { id: 'refreshments',  label: 'Refreshments',   icon: '♻️' },
    { id: 'batteryhealth', label: 'Battery Health',  icon: '🔋' },
    { id: 'relocation',    label: 'Relocation',     icon: '🚚' },
  ];

  const handleNav = (id) => {
    if (id === 'miscellaneous') {
      setMiscExpanded(e => !e);
      setActivePage('miscellaneous');
      if (setMiscSubPage) setMiscSubPage(null);
    } else {
      if (setMiscSubPage) setMiscSubPage(null);
      setActivePage(id);
    }
    if (window.innerWidth < 768) onToggle();
  };

  const handleMiscSub = (subId) => {
    setActivePage('miscellaneous');
    setMiscExpanded(true);
    setMiscSubPage(subId);
    if (window.innerWidth < 768) onToggle();
  };

  return (
    <aside className={`sidebar ${collapsed ? 'sidebar-collapsed' : ''}`}
      style={{ background: theme.bg }}>
      <style>{`
        .sidebar-brand { border-image: linear-gradient(90deg, transparent, ${theme.accent}44 40%, ${theme.accent}2a 70%, transparent) 1 !important; }
        .sidebar-footer { border-image: linear-gradient(90deg, transparent, ${theme.accent}2e 40%, ${theme.accent}1e 70%, transparent) 1 !important; }
        .nav-item.active { border-color: ${theme.accent}38 !important; }
        .nav-item.active::before { background: linear-gradient(180deg, ${theme.accent}, ${theme.accent}cc) !important; }
        .sidebar-user-avatar { background: linear-gradient(135deg, ${theme.accent}, ${theme.accent}aa) !important; box-shadow: 0 2px 10px ${theme.accent}55 !important; }
      `}</style>
      <div className="sidebar-brand">
        <button className="hamburger-btn" onClick={onToggle}
          title={collapsed ? 'Open menu' : 'Close menu'}>
          {collapsed ? <Menu size={18} color="#fff"/> : <X size={18} color="#fff"/>}
        </button>
        <div className="brand-content">
          <div>
            <div className="brand-name">{brandTitle}</div>
            <div className="brand-sub">{brandSub}</div>
          </div>
        </div>
      </div>

      <div className="sidebar-user" onClick={() => handleNav('profile')}
        title={collapsed ? username : 'View Profile'}>
        <div className="sidebar-user-avatar">{initial}</div>
        <div className="sidebar-user-info">
          <div className="sidebar-user-name">{username}</div>
          <div className="sidebar-user-role">
            {activePage === 'profile' ? '● Active' : 'View Profile'}
          </div>
        </div>
      </div>

      {!collapsed && (
        <div style={{ fontSize:9, fontWeight:700, letterSpacing:1.2,
          color:'rgba(255,255,255,0.6)', padding:'10px 20px 4px',
          textTransform:'uppercase' }}>Menu</div>
      )}

      <nav className="sidebar-nav">
        {navItems.map(({ id, label, icon: Icon, hasChildren }) => {
          const isActive = activePage === id;
          const isMiscOpen = id === 'miscellaneous' && miscExpanded && !collapsed;

          return (
            <React.Fragment key={id}>
              <button
                className={`nav-item ${isActive ? 'active' : ''}`}
                onClick={() => handleNav(id)}
                title={collapsed ? label : ''}
                style={isActive ? {
                  background:'rgba(255,255,255,0.25)',
                  borderColor:'rgba(255,255,255,0.4)',
                  boxShadow:'0 2px 16px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.3)',
                } : {}}
              >
                <div style={{
                  width:30, height:30, borderRadius:9,
                  display:'flex', alignItems:'center', justifyContent:'center',
                  flexShrink:0,
                  background: isActive ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.08)',
                  transition:'all 0.2s ease',
                }}>
                  <Icon size={15} color={isActive ? '#fff' : 'rgba(255,255,255,0.8)'} />
                </div>
                <span className="nav-label" style={{
                  fontWeight: isActive ? 700 : 500,
                  color: isActive ? '#fff' : 'rgba(255,255,255,0.8)', flex:1
                }}>{label}</span>
                {hasChildren && !collapsed && (
                  <span style={{ marginLeft:'auto', flexShrink:0, opacity:.7,
                    transition:'transform .2s',
                    transform: isMiscOpen ? 'rotate(0deg)' : 'rotate(-90deg)', display:'flex' }}>
                    <ChevronDown size={13} color="rgba(255,255,255,0.8)"/>
                  </span>
                )}
                {isActive && !collapsed && !hasChildren && (
                  <div style={{ marginLeft:'auto', width:5, height:5, borderRadius:'50%',
                    background:'#fff', flexShrink:0 }}/>
                )}
              </button>

              {id === 'miscellaneous' && isMiscOpen && (
                <div style={{
                  marginLeft:16, marginRight:8,
                  borderLeft:'2px solid rgba(255,255,255,0.15)',
                  paddingLeft:8, marginTop:2, marginBottom:4,
                  display:'flex', flexDirection:'column', gap:2,
                  animation:'subMenuIn .2s ease',
                }}>
                  <style>{`
                    @keyframes subMenuIn {
                      from { opacity:0; transform:translateY(-6px); }
                      to   { opacity:1; transform:translateY(0); }
                    }
                  `}</style>
                  {miscChildren.map(child => {
                    const isSubActive = activePage === 'miscellaneous' && miscSubPage === child.id;
                    return (
                      <button key={child.id}
                        onClick={() => handleMiscSub(child.id)}
                        style={{
                          display:'flex', alignItems:'center', gap:10,
                          padding:'8px 12px', borderRadius:10, border:'none',
                          background: isSubActive ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.05)',
                          cursor:'pointer', width:'100%', textAlign:'left',
                          transition:'background .15s', fontFamily:'inherit',
                        }}
                      >
                        <div style={{
                          width:26, height:26, borderRadius:8, flexShrink:0,
                          background: isSubActive ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.1)',
                          display:'flex', alignItems:'center', justifyContent:'center',
                          fontSize:13,
                        }}>{child.icon}</div>
                        <span style={{
                          fontSize:12, fontWeight: isSubActive ? 700 : 500,
                          color: isSubActive ? '#fff' : 'rgba(255,255,255,0.75)',
                          letterSpacing:-.2,
                        }}>{child.label}</span>
                        {isSubActive && (
                          <div style={{ marginLeft:'auto', width:4, height:4, borderRadius:'50%',
                            background:'#fff', flexShrink:0 }}/>
                        )}
                      </button>
                    );
                  })}
                </div>
              )}
            </React.Fragment>
          );
        })}
      </nav>

      {!collapsed && (
        <div style={{ fontSize:9, fontWeight:700, letterSpacing:1.2,
          color:'rgba(255,255,255,0.6)', padding:'4px 20px 4px',
          textTransform:'uppercase' }}>Account</div>
      )}

      <div className="sidebar-footer">
        {(() => {
          const isActive = activePage === 'profile';
          return (
            <button className={`nav-item ${isActive ? 'active' : ''}`}
              onClick={() => handleNav('profile')}
              title={collapsed ? 'Profile' : ''}
              style={isActive ? {
                background:'rgba(255,255,255,0.25)',
                borderColor:'rgba(255,255,255,0.4)',
                boxShadow:'0 2px 16px rgba(0,0,0,0.1)',
              } : {}}>
              <div style={{
                width:30, height:30, borderRadius:9,
                display:'flex', alignItems:'center', justifyContent:'center',
                flexShrink:0,
                background: isActive ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.08)',
                transition:'all 0.2s ease',
              }}>
                <Settings size={15} color={isActive ? '#fff' : 'rgba(255,255,255,0.8)'} />
              </div>
              <span className="nav-label" style={{
                fontWeight: isActive ? 700 : 500,
                color: isActive ? '#fff' : 'rgba(255,255,255,0.8)'
              }}>Profile</span>
              {isActive && !collapsed && (
                <div style={{ marginLeft:'auto', width:5, height:5, borderRadius:'50%',
                  background:'#fff', flexShrink:0 }}/>
              )}
            </button>
          );
        })()}

        <button className="nav-item logout" onClick={onSignOut}
          title={collapsed ? 'Sign Out' : ''}>
          <div style={{
            width:30, height:30, borderRadius:9, flexShrink:0,
            display:'flex', alignItems:'center', justifyContent:'center',
            background:'rgba(0,0,0,0.08)', transition:'all 0.2s ease',
          }}>
            <LogOut size={15} color="rgba(255,255,255,0.8)" />
          </div>
          <span className="nav-label" style={{ color:'rgba(255,255,255,0.8)', fontWeight:500 }}>
            Sign Out
          </span>
        </button>
      </div>
    </aside>
  );
}
